
    
    <div class="uk-child-width-1-1@s" uk-grid>
        <div>
            <div class="uk-background-cover uk-height-large uk-panel uk-flex-center uk-flex-middle"
                   style="background-image: url(../../assets/odoobanner.png);">
                <div class="uk-section uk-light">
                    <div class="uk-container-small uk-width-2xlarge" style="padding-top: 30px;">
                        <div><h1 class="uk-text-bold uk-padding-large uk-padding-remove-vertical"  style="margin-bottom: 10px;">ODOO App Development</h1></div>
                        <div>
                            <p class="uk-padding-large uk-text-left  uk-padding-remove-vertical" style= "font-size: 20px;">We at WebSoulLabs
                                 provide Odoo customization services for your app according to your business needs and goals.
                                  Odoo is an open source resource planning framework.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>
    
    <div class="uk-section uk-section-muted uk-padding ">
        <div class="uk-container uk-container-large">
            <h2 class="uk-text-center" style="font-weight: 600px;"> An Overview of ODOO App Development</h2>
            <p class="uk-text-justify uk-text-medium" style="font-size:18px">Odoo is one of the top notch
                 frameworks for precious business and we’re here to support and maintain your application
                  such as, customization, integration, version update, data migration, documentation etc.
                   Odoo application development is much more cost-effective compared to other frameworks
                    available. It’s modules are more user-friendly for wide range of businesses hence it 
                    is very popular because of its customization capabilities. We use Odoo framework to 
                    develop applications specific to your business needs.</p>
                 <p class="uk-text-justify uk-text-medium" style="font-size:18px">We at WebSoulLabs provide
                     affordable Odoo application development services for all type of  business seamlessly.
                      We have well industry experience in developing robust web applications, customized online
                       stores, social networking applications, health applications etc. We are not only developing
                        Odoo web application but also providing maintenance and other support services. We have also
                         developed some products to plug and play in the rapidly growing market. With the optimum usage
                          of available resources at a reasonable price we deliver end-to-end app solutions with rich
                           graphics and intuitive features.</p>
                      
        </div>
    </div>
    
   
        
    <div class="uk-container">
        
        <h2 class="uk-text-center" style="margin-bottom: 0px; font-weight: 600px;"><span>Key features of Odoo</span></h2>
        
            <p class="uk-text-center uk-text-justify uk-text-medium" style="font-size:18px">All type of tasks can be managed by
                 Odoo very efficiently and can automate the communication, prioritize the tasks and
                  notifications. Manages projects and tasks without any limitations and allow to handle
                   multiple projects. Tasks scheduling, prioritization, and email notifications can be done
                    very easily. Keeps track of all orders and quotes and their expected date of delivery.
                     It provides clear information to the management about the warehouses, stocks and stock
                      locations. Using Odoo helps to manage all payment and shipping methods to provide a
                       smooth and efficient shopping experience.</p>
                  <br>
        <div class="uk-child-width-1-2@s uk-child-width-1-3@l uk-grid-match" uk-grid>
            <div class="uk-animation-toggle" >
                <div class="uk-card uk-card-default uk-card-body  uk-animation-slide-top-small  uk-margin-bottom">
                
                    <img class="uk-align-center" src="../../assets/pro.png" width="70" height="70" style="margin-bottom: 40px;" alt="pro mang">
                    <h4 class="uk-text-center"  style="font-weight: 600;">Project Management</h4>
                </div>
            </div>
        

            <div class="uk-animation-toggle">
        
                <div class="uk-card uk-card-default uk-card-body  uk-animation-slide-top-small  uk-margin-bottom">
                    <img class="uk-align-center" src="../../assets/account.png" width="70" height="70" alt="accounting">
                    <h4 class="uk-text-center"  style="font-weight: 600;">Accounting/Finance</h4>
                </div>
            </div>


            <div class="uk-animation-toggle">
        
                <div class="uk-card uk-card-default uk-card-body  uk-animation-slide-top-small  uk-margin-bottom">
                    <img class="uk-align-center" src="../../assets/tag.png" width="70" height="70" alt="tag">
                    <h4 class="uk-text-center"  style="font-weight: 600;">Sales Management </h4>

            
                </div>
            </div>

            <div class="uk-animation-toggle">
                <div class="uk-card uk-card-default uk-card-body  uk-animation-slide-top-small  uk-margin-bottom">
                    <img class="uk-align-center" src="../../assets/wh.png" width="70" height="70" alt="warehouse">
                    <h4 class="uk-text-center"  style="font-weight: 600;">Warehouse Management</h4>
                </div>
            </div>

            <div class="uk-animation-toggle">
        
                <div class="uk-card uk-card-default uk-card-body  uk-animation-slide-top-small  uk-margin-bottom">
                    <img class="uk-align-center" src="../../assets/prom.png" width="78" height="78" alt="product">
                    <h4 class="uk-text-center"  style="font-weight: 600;">Production Management</h4>
                </div>
            </div>

            <div class="uk-animation-toggle">
                <div class="uk-card uk-card-default uk-card-body  uk-animation-slide-top-small  uk-margin-bottom">
                    <img class="uk-align-center" src="../../assets/inv.png" width="70" height="70" alt="invntr">
                    <h4 class="uk-text-center"  style="font-weight: 600;">Inventory Management</h4>
                </div>
            </div>

        
            <div class="uk-animation-toggle">
                <div class="uk-card uk-card-default uk-card-body  uk-animation-slide-top-small  uk-margin-bottom">
                    <img class="uk-align-center" src="../../assets/su.png" width="80" height="80" alt="survy">
                    <h4 class="uk-text-center"  style="font-weight: 600;">Online Survey</h4>
                </div>
            </div>
        
        

            <div class="uk-animation-toggle">
                <div class="uk-card uk-card-default uk-card-body  uk-animation-slide-top-small  uk-margin-bottom">
                    <img class="uk-align-center" src="../../assets/ge.png" width="70" height="70" alt="e-commerce">
                    <h4 class="uk-text-center"  style="font-weight: 600;">E-Commerce Management </h4>

                </div>
            </div>

            <div class="uk-animation-toggle">
                <div class="uk-card uk-card-default uk-card-body  uk-animation-slide-top-small  uk-margin-bottom">
                    <img class="uk-align-center" src="../../assets/og.png" width="70" height="70" alt="Shipping">
                    <h4 class="uk-text-center"  style="font-weight: 600;">Shipping</h4>

                </div>
            </div>
        

            <div class="uk-animation-toggle">
                <div class="uk-card uk-card-default uk-card-body uk-animation-slide-top-small  uk-margin-bottom">
                    <img class="uk-align-center" src="../../assets/crm.jpg" width="58" height="58" alt="crm">
                    <h4 class="uk-text-center"  style="font-weight: 600;">CRM</h4>

                </div>
            </div>

            <div class="uk-animation-toggle">
                <div class="uk-card uk-card-default uk-card-body uk-animation-slide-top-small  uk-margin-bottom">
                    <img class="uk-align-center" src="../../assets/HRM.jpg" width="70" height="70" alt="hrm">
                    <h4 class="uk-text-center"  style="font-weight: 600;">HRM</h4>

                </div>
            </div>
    
        </div>
        <br><br>

    </div>
      
   
     
     <br>
     <div class="uk-section uk-section-default" style="padding-top: 0px;">
        <div class="uk-container">
            <h2 class="uk-text-center" style="font-weight: 600px;"><span>Why you choose Odoo for your business?</span></h2>
            <br>
            <div class=" uk-child-width uk-child-width-1-2@l"uk-grid>
                
                <div>
                    <ul class="uk-list uk-list-disc uk-text-medium uk-text-justify" style="font-size: 18px;">
                        <li>You need to choose what you need and one can also add modules in the future.</li>
                        <li> saves lots of license cost and can be customized according to your business needs.</li>
                        <li> Ideal choice for a business with all classes with multiple business functionalities.</li>
                        <li>It takes a reasonable price for licensing compare to the other software and helps
                             our customers not to invest more in development. </li>
                        <li>Hundreds of new app and themes are available in the Odoo Marketplace. </li>
                        
                        
                        
                    </ul>
                </div>
                <div>
                    <img data-src="assets/odoo2.png" width="600" height="600" alt="" uk-img>
                </div>
            </div>
        </div>  <!--container div-->
        
    </div>  
    <br>

    <div class="uk-section  uk-padding" style=" background-color: #135796; padding-bottom: 0px;">
        <div class="uk-container uk-container-large ">
            <h1 class="uk-text-center" style="color:snow; font-weight: 600px; margin-bottom: 10px;">OODO to Enrich your Business Prospect</h1>
            <p class="uk-text-left  uk-text-medium" style="color: snow; margin-top: 10px; font-size: 18px;">Oodo functions are techniques used to combine a set of statements within a program. 
             Functions also let programmers compute a result-value and give parameters that serve as
             function .
            </p>
        
            
            <div class="uk-grid-match uk-grid-collapse uk-child-width-1-2@s uk-child-width-1-3@l   uk-text-center"style="padding-top: 20px; padding-bottom: 20px;" uk-grid>
                <div>
                    <div class="uk-card uk-card-muted  uk-card-body" style="padding-top: 0px; padding-bottom: 0px;">
                        
                        <div class="pa">
                            <span class="text-white">
                            <img src="../../assets/st.svg"  width="50" height="50" alt="svg" style="padding-top: 10px" ></span>
                            <h3 class="uk-text-center" style="color: snow; margin-top: 0px;"><strong>Implementation</strong></h3>
                            <p class="uk-text-justify " style=" color: snow;">We uses best-of-technologies
                                 for Odoo implementation. We offer a complete and efficient Odoo implementation
                                  support to our clients.</p>
                        </div>
                        
                       
                    </div>
                </div>
                <div>
                    <div class="uk-card uk-card-muted  uk-card-body" style="padding-top: 0px; padding-bottom: 0px;">
                        <div class="pa1">
                            <span class="text-white">
                            <img src="../../assets/dev.svg"  width="50" height="50" alt="svg" style="padding-top: 15px"  ></span>
                            <h3 class="uk-text-center" style="color: snow;  margin-top: 0px;"><strong>Development</strong></h3>
                            <p class="uk-text-justify uk-text-medium" style=" color: snow;">The development is rather quick and therefore
                                 we are able to gain the required functionality sooner than our rivals. </p>
                       
                        </div>
                        
                    </div>
                </div>
                <div>
                    <div class="uk-card uk-card-muted uk-card-body" style="padding-top: 0px; padding-bottom: 0px;">
                        <div class="pa2">
                            <span class="text-white">
                            <img src="../../assets/support.svg"  width="50" height="50" alt="svg" style="padding-top: 10px"></span>
                            <h3 class="uk-text-center" style="color: snow;  margin-top: 0px;"><strong>Customization</strong></h3>
                            <p class="uk-text-justify uk-text-medium" style="color: snow;">We provides high end customization services so 
                                that our clients get the full benefit of using the application, there by achieving the business goals.</p>
                       
                        </div>
                        
                    </div>
                </div>
            </div>
            
        </div>
    </div>
    <br>
    <div class="uk-section uk-section-default uk-padding" style="padding-bottom: 0px;">
        <div class="uk-container">
            <h2 class="uk-text-center" style="font-weight: 600px;"><span>Why  Odoo in WebSoulLabs?
            </span></h2>
            <br>
            <div class="uk-child-width uk-child-width-1-2@l"uk-grid>
                
                <div>
                    <ul class="uk-list uk-list-disc uk-text-medium" style="font-size: 18px;">
                        <li><b> Experienced and Dedicated Developers :</b>Our full-time developers work exclusively
                             on all project, facilitating overlapping your time zone so that you can communicate 
                             in real time.</li>
                        <li><b> Infrastructure Support & Maintenance :</b>we take care of end-to-end support & maintenance 
                            while you completely focus on your business. It's timely, reliable & hassle free.</li>
                        <li><b>Win-Win Partnership :</b>Our approach is not just to deliver your projects, but asking right questions &
                             provides suggestions and strategies for you ensuring maximum ROI.</li>
                        <li><b> 100% Transparency :</b>Customer trust is supreme for us. We guarantee this by providing access to project
                             collaboration tool  with live time tracking & regular mass. </li>
                        


                    </ul>
                </div>
                <div>
                    <img data-src="assets/odoo1.jpg" width="600" height="600" alt="odoo" uk-img>
                </div>
            </div>
        </div>  
    </div>  


    <h1 class="uk-text-center" style="margin-bottom: 0px;"><span>Related Services</span></h1>
    <BR><BR>
        
    <div class="uk-container">
        <div class="uk-grid-medium uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match uk-flex-center"  uk-grid>
            <div>
                <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                
                    <img class="uk-align-center"  src="../../assets/icons/mean1.png" width="100" height="100" alt="mean app">
                    <h4 class="uk-text-center" style="font-weight: 600;">MEAN Stack<br> Development</h4>
            
                </div>
            </div>
        

           

       
        
            <div>
                <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                    <img class="uk-border-pill uk-align-center" src="../../assets/icons/dj1.png" width="100" height="100" alt="django">
                    <h4 class="uk-text-center" style="font-weight: 600;">Django <br>Development</h4>

                </div>
            </div>
        
        </div>

    </div>
    <h1 class="uk-text-center"><span>Technology Stack</span></h1>
    <br>
    <div class="uk-container">
        <div class=" wss uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match" uk-grid>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding" >
                    <img class="uk-border-circle uk-align-center" src="assets/bit.png" width="90" height="90"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">BitGo</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/web3.png" width="90" height="90"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">Angular js</h4>
                </div>
            </div>
            
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/tru.png" width="90" height="90"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">Truffle Ethereum</h4>
                </div>
            </div>
        
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/sold.png" width="90" height="90"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">Solidity</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/we.png" width="90" height="90"
                        alt="border-circle">
                    <h4 style="margin-top: 20px; font-weight: 600;">Web3</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/via.png" width="80" height="80"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">Via BTC</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/hyp.png" width="80" height="80"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">Hyperledger</h4>
                </div>
            </div>
        
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/bl.png" width="180" height="180"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">Blockcypher</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/mobile2.jpg" width="80" height="80"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">React Js</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/web1.png" width="150" height="150"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">Node Js</h4>
                </div>
            </div>
            
        </div>
    </div>
    <br>   
       
       

